import https from "@/lib/https";
import type {
  DegreeDetail,
  DegreePayload,
  GetDegreeListParams,
} from "@/interface/masterManagement";
import type { ApiResponse, PaginationResponse } from "@/interface/common";

const BASE_URL = "/api/master/degrees/";

export const getDegreeList = async (
  params: GetDegreeListParams,
): Promise<ApiResponse<PaginationResponse<DegreeDetail> | DegreeDetail[]>> => {
  return await https.get<
    ApiResponse<PaginationResponse<DegreeDetail> | DegreeDetail[]>
  >(BASE_URL, params);
};

export const createDegree = async (
  payload: DegreePayload,
): Promise<ApiResponse<DegreeDetail>> => {
  return await https.post<ApiResponse<DegreeDetail>>(BASE_URL, payload);
};

export const updateDegree = async (
  id: number | string,
  payload: DegreePayload,
): Promise<ApiResponse<DegreeDetail>> => {
  return await https.put<ApiResponse<DegreeDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteDegree = async (
  id: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};
